<div [ngClass]="'badge-' + (color || 'blank')" [class.disabled]="disabled" class="badge">
    <div class="badge-content">
        <ng-content></ng-content>
    </div>
    <span *ngIf="hover" class="badge-focus-overlay"></span>
</div>
